import React from "react";

export const AuthContext = React.createContext({
  user: null,
  roleIds: [],
  isAuthLoading: true,
});

export function useAuth() {
  return React.useContext(AuthContext);
}